export default{
    msg:'',
    editar:{},
    lista:'',
    categorias:'',
    perfil:'',
    evento:''
}